export const APP_NAME = import.meta.env.VITE_APP_NAME
export const APP_TITLE = import.meta.env.VITE_APP_TITLE
export const APP_URL = import.meta.env.VITE_APP_URL
export const APP_DESCRIPTION = import.meta.env.VITE_APP_DESCRIPTION
export const APP_IMAGE = import.meta.env.VITE_APP_IMAGE
export const APP_STORAGE_KEY = import.meta.env.VITE_APP_STORAGE_KEY
